import "../../i18n/i18n";
import { VehiclesTable } from "./tables/vehiclesTable";
import { useVehicles } from "./useVehicles";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { ButtonDS, Spacer, triggerToast } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import {
  connectVehiclesToProviderAsync,
  selectConnectVehiclesToProviderStatus,
} from "./telemetrySlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { Vehicle, VehicleDisplayed } from "./telemetryApi";

export const AddVehiclesToProviderTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const params = useParams();
  const vehiclesListWithId = useVehicles();
  const [selectedVehicles, setSelectedVehicles] = useState<VehicleDisplayed[]>(
    [],
  );
  const connectVehiclesToProviderStatus = useAppSelector(
    selectConnectVehiclesToProviderStatus,
  );

  const filteredVehiclesListWithId = useMemo(() => {
    return vehiclesListWithId.filter(
      (v) =>
        (v.isEligible &&
          v.isEligible.toString() ===
            t("vehiclesOfACompany.column.isEligible.true") &&
          v.connectionStatus ===
            t("vehiclesOfACompany.column.connectionStatus.IDLE") &&
          !v.dataProvider) ||
        (v.connectionStatus ===
          t("vehiclesOfACompany.column.connectionStatus.REVOKED") &&
          v.dataProvider === "HIGH_MOBILITY"),
    );
  }, [t, vehiclesListWithId]);

  const addVehiclesToProvider = useCallback(() => {
    void dispatch(
      connectVehiclesToProviderAsync({
        vehicleUuids: selectedVehicles.map(
          (v) => (v as unknown as Vehicle).uuid,
        ),
        connectionPlan: "LIGHT",
      }),
    );
  }, [selectedVehicles, dispatch]);

  const checkVehiclesEligibilityAction = useMemo(() => {
    return (
      <ButtonDS
        text={t("telemetry.addVehiclesToProvider.button")}
        format="fill"
        buttonType="primary"
        onClick={addVehiclesToProvider}
        disabled={selectedVehicles.length === 0}
      />
    );
  }, [t, addVehiclesToProvider, selectedVehicles.length]);

  useEffect(() => {
    if (connectVehiclesToProviderStatus === "success") {
      triggerToast(t("telemetry.addVehiclesToProvider.success") || "", "valid");
    } else if (connectVehiclesToProviderStatus === "failed") {
      triggerToast(t("telemetry.addVehiclesToProvider.failure") || "", "error");
    }
  }, [connectVehiclesToProviderStatus, t]);

  if (params.tab !== "addVehiclesToProvider") {
    return;
  }

  return (
    <>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addVehiclesToProvider.description")}
      </StyledDescription>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addVehiclesToProvider.description2")}
      </StyledDescription>
      <Spacer y={1} />
      <VehiclesTable
        vehiclesListWithId={filteredVehiclesListWithId}
        pageName="vehiclesOfACompany"
        pageTitle="Add-to-provider"
        dataProvider="HIGH_MOBILITY"
        action={checkVehiclesEligibilityAction}
        rowsChecked={selectedVehicles}
        setRowsChecked={setSelectedVehicles}
      />
    </>
  );
};

const StyledDescription = styled.div`
  ${typographies["Header/H3"]}
`;
